import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";
import { MileStoneProps, WrapperProps } from "./types";

export const ProfileStrengthBarWrapper = styled.div<WrapperProps>`
    margin-top: ${({ showMileStones }) => (showMileStones ? "3rem" : "0")};
    position: relative;
    min-width: ${({ minWidth }) => minWidth};
    width: ${({ fullWidth }) => (fullWidth ? "100%" : "300px")};

    @media (${theme.breakpoints.mobileL}) {
        margin-top: 20px;
    }
`;

export const MileStoneHeader = styled.div`
    width: max-content;
    padding: 4px 8px;
    padding-bottom: 6px;
    border-radius: 4px;

    @media (${theme.breakpoints.mobileL}) {
        position: relative;
        right: 50px;
    }
`;

export const MileStoneIcon = styled.div`
    position: relative;
    width: 26px;
    height: 26px;
    border-radius: 50%;
`;

export const MileStone = styled.div<MileStoneProps>`
    position: absolute;
    left: ${({ left }) => left};
    bottom: -6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    ${MileStoneHeader} {
        background-color: ${({ isComplete, isVerifiedMileStone }) =>
            isComplete
                ? isVerifiedMileStone
                    ? "#00bbc7"
                    : colors.purple.primary
                : "#EFEFEF"};
    }

    ${Text.Style} {
        font-size: 11px;
        font-weight: 600;
        color: ${({ isComplete }) => (isComplete ? "#fff" : colors.grey.dark)};
    }

    ${MileStoneIcon} {
        background-color: ${({ isComplete }) =>
            isComplete ? "#00BBC7" : "#efefef"};
        border: 1px solid
            ${({ isComplete }) => (isComplete ? "#fff" : "#7c7c7c")};
    }

    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        fill: ${({ isComplete }) =>
            isComplete ? "#fff" : colors.purple.primary};
    }

    @media (${theme.breakpoints.mobileL}) {
        left: 80%;
    }
`;
